import React, { useState } from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import { Col, Modal, Row } from "react-bootstrap";
import classes from "./CancellationPolicyModal.module.css";
import {
  coachDemoImg,
  coachDemoImg2,
  starIconss,
  tableImg,
} from "../../../../constant/imagePath";
import StarRatings from "react-star-ratings";
import moment from "moment";
import {
  AiFillCalendar,
  AiFillClockCircle,
  AiOutlineLeft,
  AiOutlineRight,
} from "react-icons/ai";
import { BsChatDots } from "react-icons/bs";
import { MdPlace } from "react-icons/md";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";

const CancellationPolicyModal = ({ show, setShow, data }) => {
  const [pagitnationSteps, setPagitnationSteps] = useState(1);

  const [savedRepliesState, setSavedRepliesState] = useState([]);

  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"468px"}
        height={"188px"}
        padding={"32px"}
        showCloseIcon={true}
        // footer={true}
      >
        <div className={classes.modalContent}>
          <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
            Cancellation Policy
          </h4>
          <hr />
          <div className={classes.dFlexJustifyContentSpaceBetween}>
            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfNero,
                fontWeight: 400,
              }}
            >
              24h before lesson
            </p>
            <p style={{ ...Fonts.p1, color: Colors.errorColor }}>No Refund</p>
          </div>
          <hr />
          <div className={classes.dFlexJustifyContentSpaceBetween}>
            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfNero,
                fontWeight: 400,
              }}
            >
              Before Sep 20, 11:00am
            </p>
            <p style={{ ...Fonts.p1, color: Colors.mainBlue }}>Refund</p>
          </div>
          <hr />
          <div className={classes.dFlexJustifyContentSpaceBetween}>
            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfNero,
                fontWeight: 400,
              }}
            >
              If coach is no show up
            </p>
            <p style={{ ...Fonts.p1, color: Colors.mainBlue }}>Refund</p>
          </div>
          <hr />
          <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
            If you cancel a lesson more than three times 24 hours before the
            start of the lesson, you may be banned.
          </p>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default CancellationPolicyModal;

CancellationPolicyModal.defaultProps = {
  data: {
    dateItem: {
      icon: AiFillCalendar,
      date: "Mon Aug 16 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
    },
    timeItem: {
      icon: AiFillClockCircle,
      time: "12:30PM- 2:30PM",
    },
    placeItem: {
      icon: MdPlace,
      description: "DeWitt Clinton Park, W 54th St, New York, NY",
    },

    userData: {
      displayName: "Kate Johnson",
      photo: coachDemoImg2,
      rating: 5,
      sport: "Student",
      cancellation: "3",
      reviewTitle: "The coach did not show up for training.",
      reviewDescription:
        "The coach was 20 minutes late for training. When I reprimanded him, he was rude. In general, I am very dissatisfied with the student's behavior and ask him to be banned.",
    },

    coachData: {
      coachName: "Michael Baumgardner",
      coachImg: tableImg,
    },

    userDetailsCardsData: [
      {
        title: "Plans have changed.",
        description:
          "Unfortunately, I am having problems of a family nature. Because of this, I will not be able to attend the training",
        timeAgo: "Within 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
      {
        title: "Medical emergency",
        description:
          "Yesterday I broke my arm and spent the day in the hospital, so I could not cancel the class in advance.",
        timeAgo: "Within 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
      {
        title: "Other",
        description: "",
        timeAgo: "Before 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
    ],
  },
};
